module.exports = __webpack_public_path__ + "static/modal_idcard_front.fe8ff608.png";